export default __webpack_public_path__ + "static/LastClassTeacher-115ac312b60b676f796cc8024fdae99a.png";